export class EfaStateType {

  static UNDEFINED:string = 'undefined';
  static EMOTIONAL:string = 'emotional';
  static PHYSICAL:string = 'physical';
  static ANIMICAL:string = 'animical';
}
